import React, { useContext } from 'react';
import { generateId, AUDIO_TYPE } from 'ricos-content';
import { RicosContext, EditorContext, ModalContext, PluginsEventsContext, UploadContext } from 'ricos-context';
import AudioInsertModal from './AudioInsertModal.js';
import 'classnames';
import 'react-player';
import 'wix-rich-content-common';
import 'wix-rich-content-ui-components';
import '../style-inject.es-746bb8ed.js';
import '../dataHooks.js';
import './AudioUploadModal.js';
import 'wix-rich-content-plugin-commons';
import '../consts.js';
import 'ricos-types';
import '../toolbar/audioPluginService.js';
import 'lodash';
import './MediaURLInputModal.js';
import './utils.js';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const InsertModal = ({
  nodeId,
  componentData,
  handleFileSelection,
  handleFileUpload,
  fetchData,
  embedType,
  modalId,
  showCloseButton
}) => {
  const { t, isMobile, languageDir } = useContext(RicosContext);
  const { getEditorCommands } = useContext(EditorContext);
  const modalService = useContext(ModalContext) || {};
  const pluginsEvents = useContext(PluginsEventsContext);
  const { uploadService, updateService } = useContext(UploadContext);
  const closeModal = () => {
    modalService.closeModal(modalId);
  };
  const addBlockWithFocus = (insertBlock) => setTimeout(() => insertBlock(), 50);
  const onConfirm = (audio) => {
    const id = generateId();
    const insertAudio = () => getEditorCommands().insertBlockWithBlankLines(AUDIO_TYPE, __spreadProps(__spreadValues({}, audio), { id }));
    addBlockWithFocus(insertAudio);
    return { newBlock: { key: id } };
  };
  const onReplace = (audio) => {
    if (nodeId) {
      const insertAudio = () => getEditorCommands().setBlock(nodeId, AUDIO_TYPE, audio);
      addBlockWithFocus(insertAudio);
    }
  };
  const pluginEvents = {
    onPluginsPopOverTabSwitch: (data) => pluginsEvents.publishPluginPopoverTabSwitch(data),
    onPluginsPopOverClick: (data) => pluginsEvents.publishPluginPopoverClick(data)
  };
  return /* @__PURE__ */ React.createElement(
    AudioInsertModal,
    {
      componentData,
      t,
      isMobile,
      languageDir,
      closeModal,
      onReplace,
      onConfirm: !nodeId ? onConfirm : void 0,
      uploadService,
      updateService,
      helpers: pluginEvents,
      handleFileSelection,
      handleFileUpload,
      embedType,
      fetchData,
      showCloseButton
    }
  );
};

export { InsertModal as default };
//# sourceMappingURL=InsertModal.js.map
